import IMInventoryEntryForm from './IMInventoryEntryForm';

export default IMInventoryEntryForm;
